// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1128":"7ab265b3","1164":"65e537bb","2000":"b6a1d1e1","2589":"d6fdf0fb","6418":"6b898db9","7912":"75edc61e"}[chunkId] + ".css";
};